import routeReplaceSelf from '@/utils/routeReplaceSelf';

const globalManagementRouter = {
    path: "globalCustList",
    name: "globalCustList",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'customer',
        icon: 'HSIconfont hs-icon-personal',
        showRealm: ['GLOBAL']
    },
    children: [
        {
            path: 'globalManagement',
            name: 'globalManagement',
            component: routeReplaceSelf(() => import('@/views/globalManagement/index.vue')),
            meta: { code: 'customer:management' },
            children: [
                {
                    path: 'globalCustNowa',
                    name: 'globalCustNowa',
                    hidden: true,
                    component: () => import('@/views/globalCustNowa'),
                    meta: {
                        code: 'customer_management_nowa',
                        activeMenu: 'globalManagement',
                    },
                }
            ]

        }
    ]
};

export default globalManagementRouter;
